'use client';

import Script from 'next/script';
import { IHubSpotForm } from './types';
import styles from './HubSpotForm.module.scss';
import { extractHubSpotFormData } from '@/utils/helpers';
import { useEffect, useState } from 'react';
import HubSpotFormSkeleton from './HubSpotFormSkeleton';
import './HubspotLegacyForm.scss';

export default function HubSpotLegacyForm(props: IHubSpotForm) {
  const { embedCode, instanceId } = props;
  const formInstanceId = instanceId || 'hubspot-form';
  const { scriptSrc } = extractHubSpotFormData(embedCode);
  const [isFormReady, setIsFormReady] = useState(false);

  const trackConversion = () => {
    const gtag = (
      window as Window & {
        gtag?: (command: string, eventName: string, params: Record<string, string | number>) => void;
      }
    ).gtag;

    gtag?.('event', 'conversion', {
      send_to: 'AW-18367841177/GSfVCPHs_tocEJmHvLZE',
      value: 1.0,
      currency: 'AUD',
    });
  };

  useEffect(() => {
    const { portalId, formId, region } = extractHubSpotFormData(embedCode);

    setTimeout(() => {
      window.hbspt?.forms?.create({
        portalId,
        formId,
        region,
        target: `#${formInstanceId}`,
        formInstanceId,
        cssClass: styles.hubspotForm,
        css: '',
        onFormReady: () => setIsFormReady(true),
        onFormSubmitted: trackConversion,
      });
    }, 500);
  }, [embedCode, formInstanceId]);

  if (!embedCode) {
    return null;
  }

  return (
    <div>
      {!isFormReady && <HubSpotFormSkeleton className='rounded-lg bg-white p-6' />}
      <div id={formInstanceId} />
      <Script charSet='utf-8' type='text/javascript' src={scriptSrc}></Script>
    </div>
  );
}
